export default __webpack_public_path__ + "static/media/english-to-portuguese-screenshot-05.56a65d7c.png";